import { render, staticRenderFns } from "./NotificationsView.vue?vue&type=template&id=c86b84d2"
import script from "./NotificationsView.vue?vue&type=script&lang=js"
export * from "./NotificationsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports